export const NO_TTL_LIMIT = 'NO_TTL_LIMIT'
export const SECONDS = 'SECONDS'

export const control_options = [{
    label: 'Только вручную',
    value: NO_TTL_LIMIT,
}, {
    label: 'Автоматически по истечению "времени жизни"',
    value: SECONDS,
},]